import $ from 'jquery';
export default (function () {
  if ($('.share-buttons').length && document.querySelector('#main-row-column')) {
    import(
    /* webpackChunkName: "share-buttons" */
    './share-buttons').then(function (module) {
      return module.default();
    }) // eslint-disable-next-line no-unused-vars
    .catch(function (error) {
      return 'An error occurred while loading search-filters';
    });
  }
});